var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInspiration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  style: {
    transform: "scale(1.15) translate(-.5px,-1.5px)"
  },
  viewBox: "0 0 30 30"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_2_G-inspiration",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: 0,
  keySplines: "0.185 0 0.232 1;0.185 0 0.232 1;0.474 0 0.216 1;0.689 0 0.459 1;0.448 0 0.221 1;0 0 0 0",
  keyTimes: "0;0.0282486;0.1299435;0.3728814;0.6158192;0.9152542;1",
  repeatCount: 1,
  to: 0,
  type: "rotate",
  values: "0;0;-17;15;-5;0;0"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_2_G-inspiration",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: "-3.032 -3.12",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-3.032 -3.12",
  type: "translate",
  values: "-3.032 -3.12;-3.032 -3.12"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_1_G_N_5_T_0-inspiration",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: 0,
  keySplines: "0.185 0 0.232 1;0.185 0 0.232 1;0.474 0 0.216 1;0.689 0 0.459 1;0.448 0 0.221 1;0 0 0 0",
  keyTimes: "0;0.0282486;0.1299435;0.3728814;0.6158192;0.9152542;1",
  repeatCount: 1,
  to: 0,
  type: "rotate",
  values: "0;0;-17;15;-5;0;0"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_1_G_N_5_T_0-inspiration",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: "-3.032 -3.12",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-3.032 -3.12",
  type: "translate",
  values: "-3.032 -3.12;-3.032 -3.12"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_N_5_T_0-inspiration",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: 0,
  keySplines: "0.185 0 0.232 1;0.185 0 0.232 1;0.474 0 0.216 1;0.689 0 0.459 1;0.448 0 0.221 1;0 0 0 0",
  keyTimes: "0;0.0282486;0.1299435;0.3728814;0.6158192;0.9152542;1",
  repeatCount: 1,
  to: 0,
  type: "rotate",
  values: "0;0;-17;15;-5;0;0"
}), /*#__PURE__*/React.createElement("animateTransform", {
  xlinkHref: "#_R_G_L_0_G_N_5_T_0-inspiration",
  fill: "freeze",
  additive: "sum",
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: "-3.032 -3.12",
  keySplines: "0 0 1 1",
  keyTimes: "0;1",
  repeatCount: 1,
  to: "-3.032 -3.12",
  type: "translate",
  values: "-3.032 -3.12;-3.032 -3.12"
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_2_G-inspiration",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  keyPoints: "0;0.06;0.5;0.94;1;1",
  keySplines: "0.185 0 0.232 1;0.474 0 0.216 1;0.689 0 0.459 1;0.448 0 0.221 1;0 0 0 0",
  keyTimes: "0;0.1016949;0.3276836;0.5875706;0.8870056;1",
  path: "M-20.01 -23.22 C-20.01,-23.22 -20.01,-22.91 -20.01,-22.91 C-20.01,-22.91 -20.01,-25.24 -20.01,-25.24 C-20.01,-25.24 -20.01,-22.91 -20.01,-22.91 C-20.01,-22.91 -20.01,-23.17 -20.01,-23.22 C-20.01,-23.22 -20.01,-23.22 -20.01,-23.22",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_1_G_N_5_T_0-inspiration",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  keyPoints: "0;0.06;0.5;0.94;1;1",
  keySplines: "0.185 0 0.232 1;0.474 0 0.216 1;0.689 0 0.459 1;0.448 0 0.221 1;0 0 0 0",
  keyTimes: "0;0.1016949;0.3276836;0.5875706;0.8870056;1",
  path: "M-20.01 -23.22 C-20.01,-23.22 -20.01,-22.91 -20.01,-22.91 C-20.01,-22.91 -20.01,-25.24 -20.01,-25.24 C-20.01,-25.24 -20.01,-22.91 -20.01,-22.91 C-20.01,-22.91 -20.01,-23.17 -20.01,-23.22 C-20.01,-23.22 -20.01,-23.22 -20.01,-23.22",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animateMotion", {
  xlinkHref: "#_R_G_L_0_G_N_5_T_0-inspiration",
  fill: "freeze",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  keyPoints: "0;0.06;0.5;0.94;1;1",
  keySplines: "0.185 0 0.232 1;0.474 0 0.216 1;0.689 0 0.459 1;0.448 0 0.221 1;0 0 0 0",
  keyTimes: "0;0.1016949;0.3276836;0.5875706;0.8870056;1",
  path: "M-20.01 -23.22 C-20.01,-23.22 -20.01,-22.91 -20.01,-22.91 C-20.01,-22.91 -20.01,-25.24 -20.01,-25.24 C-20.01,-25.24 -20.01,-22.91 -20.01,-22.91 C-20.01,-22.91 -20.01,-23.17 -20.01,-23.22 C-20.01,-23.22 -20.01,-23.22 -20.01,-23.22",
  repeatCount: 1
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#_R_G_L_1_G_D_0_P_0-inspiration",
  fill: "freeze",
  attributeName: "d",
  attributeType: "XML",
  begin: "0s",
  calcMode: "spline",
  dur: "1.475s",
  from: "M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z",
  keySplines: "1 0 1 1;0.333 0.739 0.514 0;0.333 0.686 0.667 0.379;0.333 0.621 0.514 0;0.333 0.686 0.667 0.379;0 0 0 0.956;0 0 0 0",
  keyTimes: "0;0.180791;0.2429379;0.3050847;0.3615819;0.4237288;0.6384181;1",
  repeatCount: 1,
  to: "M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z",
  values: "M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z ;M-6.47 -7.43 C-6.47,-7.43 -6.38,-7.33 -6.38,-7.33 C-6.38,-7.33 -3.76,-4.36 -3.76,-4.36 C-3.76,-4.36 -3.53,-4.08 -3.53,-4.08 C-3.53,-4.08 -2.47,-2.86 -2.47,-2.86 C-2.47,-2.86 -1.47,-1.7 -1.47,-1.7 C-1.47,-1.7 1.2,1.35 1.2,1.35 C1.2,1.35 1.58,1.79 1.58,1.79 C1.58,1.79 4.87,5.59 4.87,5.59 C4.87,5.59 5.5,6.29 5.5,6.29 C5.5,6.29 4.46,5.09 4.46,5.09 C4.46,5.09 4.45,5.09 4.45,5.09 C4.45,5.09 4.45,5.1 4.45,5.1 C4.45,5.1 5.51,6.3 5.51,6.3 C5.51,6.3 4.89,5.59 4.89,5.59 C4.89,5.59 1.57,1.79 1.57,1.79 C1.57,1.79 1.2,1.34 1.2,1.34 C1.2,1.34 -1.46,-1.69 -1.46,-1.69 C-1.46,-1.69 -2.49,-2.86 -2.49,-2.86 C-2.49,-2.86 -3.53,-4.09 -3.53,-4.09 C-3.53,-4.09 -3.76,-4.37 -3.76,-4.37 C-3.76,-4.37 -6.47,-7.43 -6.47,-7.43z ;M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z ;M-6.44 -7.44 C-6.44,-7.44 -6.45,-7.44 -6.45,-7.44 C-6.45,-7.44 -3.76,-4.36 -3.76,-4.36 C-3.76,-4.36 -3.53,-4.08 -3.53,-4.08 C-3.53,-4.08 -2.47,-2.86 -2.47,-2.86 C-2.47,-2.86 -1.47,-1.7 -1.47,-1.7 C-1.47,-1.7 1.2,1.35 1.2,1.35 C1.2,1.35 1.58,1.79 1.58,1.79 C1.58,1.79 4.87,5.59 4.87,5.59 C4.87,5.59 5.5,6.29 5.5,6.29 C5.5,6.29 4.46,5.09 4.46,5.09 C4.46,5.09 4.45,5.09 4.45,5.09 C4.45,5.09 4.45,5.1 4.45,5.1 C4.45,5.1 5.51,6.3 5.51,6.3 C5.51,6.3 4.89,5.59 4.89,5.59 C4.89,5.59 1.57,1.79 1.57,1.79 C1.57,1.79 1.2,1.34 1.2,1.34 C1.2,1.34 -1.46,-1.69 -1.46,-1.69 C-1.46,-1.69 -2.49,-2.86 -2.49,-2.86 C-2.49,-2.86 -3.53,-4.09 -3.53,-4.09 C-3.53,-4.09 -3.76,-4.37 -3.76,-4.37 C-3.76,-4.37 -6.44,-7.44 -6.44,-7.44z ;M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z ;M-6.44 -7.44 C-6.44,-7.44 -6.45,-7.44 -6.45,-7.44 C-6.45,-7.44 -3.76,-4.36 -3.76,-4.36 C-3.76,-4.36 -3.53,-4.08 -3.53,-4.08 C-3.53,-4.08 -2.47,-2.86 -2.47,-2.86 C-2.47,-2.86 -1.47,-1.7 -1.47,-1.7 C-1.47,-1.7 1.2,1.35 1.2,1.35 C1.2,1.35 1.58,1.79 1.58,1.79 C1.58,1.79 4.87,5.59 4.87,5.59 C4.87,5.59 5.5,6.29 5.5,6.29 C5.5,6.29 4.46,5.09 4.46,5.09 C4.46,5.09 4.45,5.09 4.45,5.09 C4.45,5.09 4.45,5.1 4.45,5.1 C4.45,5.1 5.51,6.3 5.51,6.3 C5.51,6.3 4.89,5.59 4.89,5.59 C4.89,5.59 1.57,1.79 1.57,1.79 C1.57,1.79 1.2,1.34 1.2,1.34 C1.2,1.34 -1.46,-1.69 -1.46,-1.69 C-1.46,-1.69 -2.49,-2.86 -2.49,-2.86 C-2.49,-2.86 -3.53,-4.09 -3.53,-4.09 C-3.53,-4.09 -3.76,-4.37 -3.76,-4.37 C-3.76,-4.37 -6.44,-7.44 -6.44,-7.44z ;M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z ;M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z"
}), /*#__PURE__*/React.createElement("animate", {
  xlinkHref: "#time_group-inspiration",
  attributeName: "opacity",
  attributeType: "XML",
  dur: "1s",
  from: 0,
  to: 1
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "_R_G-inspiration",
  transform: "translate(45.25, 49.75) translate(0, 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_2_G_N_1_T_0-inspiration"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_2_G-inspiration"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_2_G_D_0_P_0-inspiration",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 1.5,
  d: "M2.19 2.19 C2.19,2.19 -2.41,-2.41 -2.41,-2.41"
}))), /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_1_G_N_5_N_1_T_0-inspiration"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_1_G_N_5_T_0-inspiration"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_1_G-inspiration",
  transform: "translate(-7.288, -7.877) translate(0, 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_1_G_D_0_P_0-inspiration",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 1.5,
  d: "M-5.84 -7.98 C-6.5,-8.13 -7.11,-7.59 -7.05,-6.91 C-7.05,-6.91 -6.58,-1.91 -6.58,-1.91 C-6.56,-1.7 -6.61,-1.49 -6.72,-1.31 C-6.72,-1.31 -9.25,3.03 -9.25,3.03 C-9.6,3.62 -9.27,4.36 -8.61,4.51 C-8.61,4.51 -3.7,5.61 -3.7,5.61 C-3.5,5.66 -3.32,5.77 -3.18,5.92 C-3.18,5.92 0.17,9.68 0.17,9.68 C0.62,10.18 1.43,10.11 1.77,9.52 C1.77,9.52 4.34,5.2 4.34,5.2 C4.42,5.05 4.55,4.93 4.69,4.85 C4.72,4.83 4.76,4.81 4.8,4.79 C4.8,4.79 9.4,2.77 9.4,2.77 C10.02,2.5 10.2,1.71 9.75,1.2 C9.75,1.2 6.43,-2.58 6.43,-2.58 C6.29,-2.73 6.2,-2.93 6.18,-3.14 C6.18,-3.14 5.69,-8.14 5.69,-8.14 C5.62,-8.81 4.92,-9.23 4.29,-8.96 C4.29,-8.96 -0.32,-6.97 -0.32,-6.97 C-0.51,-6.89 -0.73,-6.86 -0.93,-6.91 C-0.93,-6.91 -5.84,-7.98 -5.84,-7.98z"
})))), /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_N_5_N_1_T_0-inspiration"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G_N_5_T_0-inspiration"
}, /*#__PURE__*/React.createElement("g", {
  id: "_R_G_L_0_G-inspiration",
  transform: "translate(-6.295, -6.911) scale(0.02197, 0.02197) translate(0, 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_D_0_P_0-inspiration",
  fill: "currentColor",
  fillOpacity: 1,
  fillRule: "nonzero",
  d: "M398.74 378.76 C398.74,378.76 347.69,423.6 347.69,423.6 C347.69,423.6 398.96,475.54 398.96,475.54 C398.96,475.54 447.57,427.15 447.57,427.15 C447.57,427.15 398.74,378.76 398.74,378.76z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_R_G_L_0_G_D_1_P_0-inspiration",
  fill: "none",
  stroke: "red",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 1,
  strokeWidth: 0,
  d: "M398.74 378.76 C398.74,378.76 347.69,423.6 347.69,423.6 C347.69,423.6 398.96,475.54 398.96,475.54 C398.96,475.54 447.57,427.15 447.57,427.15 C447.57,427.15 398.74,378.76 398.74,378.76z"
})))))));
export default SvgInspiration;